import { Component, OnInit } from '@angular/core';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-section-gallery',
  templateUrl: './section-gallery.component.html',
  styleUrls: ['./section-gallery.component.scss']
})
export class SectionGalleryComponent implements OnInit {
  carosellItemClone: any;
  buffer: any;
  start: any;
  carosellItem: any;
  total_slide: number;
  banners: { img_url: string; }[];
  windowWith: number;
  faChevronLeft=faChevronLeft
  faChevronRight=faChevronRight
  alumni:  any
  constructor() { }

  ngOnInit(): void {
   
    this.banners = [
      {
        'img_url' :'/assets/image/gallery2.jpeg'
      },
      {
        'img_url' :'/assets/image/gallery1.jpeg'
      },
     
      {
        'img_url' :'/assets/image/gallery3.jpeg'
      },
      {
        'img_url' :'/assets/image/gallery4.jpeg'
      },
      {
        'img_url' :'/assets/image/gallery5.jpeg'
      },
      {
        'img_url' :'/assets/image/gallery6.jpeg'
      },
      {
        'img_url' :'/assets/image/gallery7.jpeg'
      },
     
      
     
     
    ]
        
      var h = window.innerHeight;

      console.log(window.innerWidth)
      if(window.innerWidth < 450){
        this.carosellItem = window.innerWidth/1
        this.carosellItemClone = window.innerWidth/1
      }else{
        this.carosellItem = window.innerWidth/1.5
        this.carosellItemClone = window.innerWidth/2
      }
    
  
      
      
     

      this.total_slide = 8
      this.windowWith =( window.innerWidth) *this.total_slide;
      this.buffer =  this.carosellItem * (this.total_slide / 1.5)
      this.start = this.carosellItemClone
  }


  scrollLeft(){
    //console.log(this.buffer)
  
  
   
     this.carosellItemClone = this.carosellItemClone + this.carosellItem
     if(this.carosellItemClone>=this.buffer){
      this.carosellItemClone = this.start
     }
    // console.log( this.carosellItemClone)
  }

  
  scrollRight(){
   
  
   
     this.carosellItemClone = this.carosellItemClone - this.carosellItem
     if(this.carosellItemClone<this.start){
      this.carosellItemClone =  ( this.carosellItem * (this.total_slide - 3)) + window.innerWidth/4.5
     }
   //  console.log( this.carosellItemClone)
  }

  navToRight(item,i){
     item.is_selected = false
    let next = i+1
    let first = 0
    let last = 2


    if(next > 2){
      next = first
    }if(next < 0) {
      next= last
    }

    console.log(next)
    this.alumni[next].is_selected = true
  }
  navToLeft(item,i){
    item.is_selected = false
   let next = i-1
   let first = 0
   let last = 2


   if(next > 3){
     next = first
   }if(next < 0) {
     next= last
   }

   console.log(next)
   this.alumni[next].is_selected = true
 }

}
